var scope_0 = require('/opt/buildhome/repo/deck/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8670c838ff107f73aae941f7d534499d.js').default;export default
        Object.assign({}, scope_0 )
    